// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BreadcrumbsService} from "./breadcrumbs.service";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {COMMON_MAT_MENU_IMPORTS} from "../../shared/import-groups/Common";
import {DblClickCopyDirective} from "../../directives/dbl-click-copy.directive";
import {MatTooltip} from "@angular/material/tooltip";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    imports: [
        CommonModule,
        DblClickCopyDirective,
        COMMON_MAT_MENU_IMPORTS,
        MatTooltip
    ],
    encapsulation: ViewEncapsulation.None
})
export class BreadcrumbsComponent implements OnDestroy, OnInit {
    private readonly onDestroy = new Subject<void>();
    breadcrumbs: string[] = [];

    constructor(private cps: BreadcrumbsService) {
        this.cps.breadcrumbsChanged.pipe(takeUntil(this.onDestroy)).subscribe(bc => this.breadcrumbs = bc);
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.unsubscribe();
    }
}
